import {
  FullStory as FullStoryLogger,
  init as initializeFullStory,
} from "@fullstory/browser";
import type { V2OperationOptions } from "@fullstory/snippet";
import { FullStoryClient } from "./client";

// eslint-disable-next-line unicorn/prefer-global-this -- disable to get version bump through
const isWindow = (): boolean => typeof window !== "undefined";

let resolveFullstory: () => void;

export type FullStoryParameters = { orgId: string };
export const FullStory = ({ orgId }: FullStoryParameters) => (
  <>
    <script>{"window['_fs_capture_on_startup'] = false;"}</script>
    <FullStoryClient orgId={orgId} />
  </>
);

FullStory.initialize = ({ orgId }: FullStoryParameters) => {
  if (isWindow()) {
    initializeFullStory({ orgId }, () => {
      resolveFullstory();
    });
  }
};

FullStory.ready = new Promise<void>((resolve) => {
  resolveFullstory = () => {
    resolve();
  };
});

FullStory.setProperties = async ({
  properties,
  ...options
}: V2OperationOptions["setProperties"]) => {
  await FullStory.ready;
  FullStoryLogger("setProperties", {
    ...options,
    properties,
  });
};
